module.exports = __webpack_public_path__ + "img/4.19f6ec5b.jpg";